<div class="loading-overlay"
     *ngIf="!isInline"></div>
<p-progressSpinner styleClass="custom-spinner"
                   class="spinner"
                   [class.tiny]="isInline"
                   strokeWidth="2"
                   fill="none"
                   animationDuration="2s"></p-progressSpinner>
